// extracted by mini-css-extract-plugin
export var chatHtmlText = "_qu-2";
export var chatLink = "_qu-0";
export var chatText = "_qu-1";